import i18n from 'shared/i18n';

import { formatRiskValue } from 'components/helpers/resources/riskMatrix';

const digits = /(\d+)/g;

$(() => {
  if ($('[data-inline-nested-attributes]').length) {
    const inlineNestedAttributes = {
      setup() {
        this.enableAddEvent();
        this.removeEventListener();
        this.enableRemoveEvent();
      },

      enableAddEvent() {
        const _this = this;
        const addButton = $('[data-element-name="add-nested-attributes"]');

        addButton.click(() => {
          _this.addAttributes();
          _this.enableRemoveEvent();

          if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
            // animation issues on mobile devices, so no animation used
            $('html, body').scrollTop($('.content-wrapper').height());
          } else {
            $('html, body').animate(
              { scrollTop: $('.content-wrapper').height() },
              'slow',
            );
          }
        });
      },

      removeEventListener() {
        const _this = this;
        this.removeClickEnabler.call(this);

        $('[data-inline-nested-attributes]').on('modifiedattributes', () => {
          _this.removeClickEnabler();
        });
      },

      triggerModified() {
        $('[data-inline-nested-attributes]').trigger('modifiedattributes');
      },

      removeClickEnabler() {
        const _this = this;

        if ($('[data-nested-attributes]').length > 1) {
          _this.enableRemoveClick();
        } else {
          _this.disableRemoveClick();
        }
      },

      addPopover(button) {
        $(button).popover({
          content: i18n.t('shared.inline-nested-attributes.tooltip', {
            ns: 'js',
          }),
          placement: 'top',
          trigger: 'hover',
        });

        $(button).data('bs.popover').tip().addClass('custom-popover');
      },

      disableRemoveClick() {
        const _this = this;

        $(['[data-remove-nested-attributes]']).each((index, button) => {
          $(button).addClass('disabled hover-popover');
          $(button).attr('data-disabled', true);
          _this.addPopover(button);
        });
      },

      enableRemoveClick() {
        $(['[data-remove-nested-attributes]']).each((index, button) => {
          if ($(button).hasClass('disabled')) {
            $(button).removeClass('disabled hover-popover');
            $(button).attr('data-disabled', false);
            $(button).popover('destroy');
          }
        });
      },

      addAttributes() {
        const _this = this;
        const lastAttributes = $('[data-nested-attributes]').last();
        const objectIndex = lastAttributes.data('object-index');

        const removeLink =
          "<a href='#0' class='tw-apply-outlined-button tw-apply-outlined-button--md tw-apply-outlined-button--red tw-apply-outlined-button--on-light pull-right' data-remove-nested-attributes='true' data-toggle='modal' data-target='#remove-nested-attributes-modal-" +
          objectIndex +
          "'><img src='" +
          HandshqApp.rails.trashRedIconSvgPath +
          "' aria-hidden='true'><span class='tw-ml-2'>" +
          i18n.t('shared.inline-nested-attributes.removeText', { ns: 'js' }) +
          '</span></a>';

        const linkWrapper =
          "<div class='col-sm-12 remove-record'><div class='form-group'>" +
          removeLink +
          '</div></div>';

        const clone = lastAttributes.clone(false);

        $(clone).insertAfter(lastAttributes);

        _this.modifyButtons(clone, linkWrapper);
        _this.modifyFields(clone);
        _this.modifyRiskAssessment(clone);
        _this.modifyNestedAttributesOptions(clone);
        _this.modifyStateWrappedAttachmentsApp(clone);
        _this.triggerModified();

        ReactRailsUJS.mountComponents(clone[0]);
      },

      removeAttributes() {
        const _this = this;
        $('#modal').modal('hide');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        $(this).closest('[data-nested-attributes]').remove();
      },

      enableRemoveEvent() {
        const _this = this;
        const removeButton = $(
          "button[name='remove-nested-attributes']",
        ).last();

        removeButton.click(function () {
          _this.removeAttributes.call(this);
          _this.triggerModified();
        });

        removeButton.closest('.remove-modal').keyup(function (event) {
          const keycode = event.keyCode ? event.keyCode : event.which;

          if (keycode === '13') {
            _this.removeAttributes.call(this);
            _this.triggerModified();
          }

          event.stopPropagation();
        });
      },

      modifyButtons(clone, buttonWrapper) {
        this.removeRecord(clone, '.remove-record');
        $(clone).append(buttonWrapper);
        this.removeRecord(clone, '.delete-record');
      },

      removeRecord(clone, selector) {
        if ($(clone).find(selector).length) {
          $(clone).find(selector).remove();
        }
      },

      modifyFields(clone) {
        const _this = this;

        $(clone).each(function (index, elements) {
          $(elements)
            .find('label')
            .each(function () {
              _this.incrementAttributeNumbers.call(this, 'for');
            });

          $(elements)
            .find('input, select, textarea')
            .each(function () {
              _this.incrementAttributeNumbers.call(this, 'id');
              _this.incrementAttributeNumbers.call(this, 'name');
            });

          $(elements)
            .find('.remove-modal')
            .each(function () {
              _this.incrementAttributeNumbers.call(this, 'id');
            });

          $(elements)
            .find('.remove-record a')
            .each(function () {
              _this.incrementAttributeNumbers.call(this, 'data-target');
            });

          _this.incrementAttributeNumbers.call(this, 'data-object-index');
        });
      },

      modifyRiskAssessment(clone) {
        const riskSelectionSidePanelProps = JSON.parse(
          $(
            '[data-react-class="riskRegister/riskSelectionSidePanel/EntryPoint"]',
          ).attr('data-react-props'),
        );

        const { riskMatrix, severityColourMap } =
          riskSelectionSidePanelProps.wrappedProps;

        const firstRowId = riskMatrix.included.find(
          (inclusion) =>
            inclusion.type === 'riskMatrixRow' &&
            inclusion.attributes.position === 1,
        ).id;

        const firstEntry = riskMatrix.included.find(
          (inclusion) =>
            inclusion.type === 'riskMatrixEntry' &&
            inclusion.relationships.row.data.id === firstRowId &&
            inclusion.attributes.position === 1,
        );

        const entryId = firstEntry.id;
        const entryValue = firstEntry.attributes.value;
        const entrySeverity = firstEntry.attributes.severity;

        if ($('.task-form').length) {
          $(clone)
            .find('[data-element-name="risk-selector-input"]')
            .each(function () {
              $(this).attr('value', entryId);
            });

          $(clone)
            .find('[data-element-name="risk-display"]')
            .each(function () {
              $(this).text(formatRiskValue(entryValue));

              Object.keys(severityColourMap).forEach((severityName) => {
                const { backgroundColor, textColor } =
                  severityColourMap[severityName];
                $(this).removeClass(backgroundColor);
                $(this).removeClass(textColor);
              });

              $(this).addClass(
                severityColourMap[entrySeverity].backgroundColor,
                severityColourMap[entrySeverity].textColor,
              );
            });
        }
      },

      modifyNestedAttributesOptions: function modifyNestedAttributesOptions(
        clone,
      ) {
        const entryPoint = $(clone).find(
          '[data-react-class="assignedPersonsAtRisk/selectAndInputFieldsForNestedAttribute/EntryPoint"]',
        );

        entryPoint.children().remove();

        const previousProps = JSON.parse(entryPoint.attr('data-react-props'));

        const previousNestedNameAttribute =
          previousProps.wrappedProps.nestedNameAttribute;

        const newNestedNameAttribute = previousNestedNameAttribute.replace(
          digits,
          parseInt(previousNestedNameAttribute.match(digits)[0], 10) + 1,
        );

        entryPoint.attr(
          'data-react-props',
          JSON.stringify({
            contextProps: { ...previousProps.contextProps },
            wrappedProps: {
              ...previousProps.wrappedProps,
              assignedPersonsAtRisk: { data: [] },
              nestedNameAttribute: newNestedNameAttribute,
              shouldInitiallySelectDefaultRisk: true,
            },
          }),
        );
      },

      modifyStateWrappedAttachmentsApp:
        function modifyStateWrappedAttachmentsApp(clone) {
          const stateWrappedAttachmentsApp = $(clone).find(
            '[data-react-class="apps/StateWrappedAttachmentsApp"]',
          );
          stateWrappedAttachmentsApp.children().remove();
          const previousStateWrappedAttachmentsAppProps = JSON.parse(
            stateWrappedAttachmentsApp.attr('data-react-props'),
          );

          const previousAttachmentIdsField =
            previousStateWrappedAttachmentsAppProps.wrappedProps
              .attachmentIdsField;
          const newAttachmentsIdsField = previousAttachmentIdsField.replace(
            digits,
            parseInt(previousAttachmentIdsField.match(digits)[0], 10) + 1,
          );

          const previousAttachmentsAttributesField =
            previousStateWrappedAttachmentsAppProps.wrappedProps
              .attachmentsAttributesField;
          const newAttachmentsAttributesField =
            previousAttachmentsAttributesField.replace(
              digits,
              parseInt(
                previousAttachmentsAttributesField.match(digits)[0],
                10,
              ) + 1,
            );

          stateWrappedAttachmentsApp.attr(
            'data-react-props',
            JSON.stringify({
              contextProps: {
                ...previousStateWrappedAttachmentsAppProps.contextProps,
              },
              wrappedProps: {
                seedAttachments: { data: [], included: [] },
                attachmentIdsField: newAttachmentsIdsField,
                attachmentsAttributesField: newAttachmentsAttributesField,
              },
            }),
          );
        },

      incrementAttributeNumbers(attributeName) {
        const currentAttribute = this.getAttribute(attributeName);

        if (currentAttribute) {
          const numbersInAttribute = currentAttribute.match(digits);

          if (numbersInAttribute) {
            const newIndex = parseInt(numbersInAttribute[0], 10) + 1;
            this.setAttribute(
              attributeName,
              currentAttribute.replace(digits, newIndex),
            );
            this.value = '';
          }
        }
      },
    };

    inlineNestedAttributes.setup();
  }
});
